export default __webpack_public_path__ + "static/media/cel1back.299d3724.png";